// removed by extract-text-webpack-plugin
module.exports = {"masthead":"Masthead-style__masthead__4a0f200","isTrade":"Masthead-style__isTrade__4a0f200"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Masthead/Masthead-style.scss
// module id = ./src/components/Masthead/Masthead-style.scss
// module chunks = 4